<template>
  <div :class="{active: showResponse}">
    <div class="upper">
      <button type="button" @click.prevent="toggleResponse">
        {{displayName}}
        <sprite name="iconDownDir" class="down-arrow" />
      </button>
      <div class="ratings">
        <ratings :range="review.rubrics.scoreRange" v-model="review.averageScore" :read-only="true" :stars="review.rubrics.criteria.length == 1" />
      </div>
    </div>
    <transition>
      <div class="response" v-if="showResponse">
        <rubric-criteria :rubric="review.rubrics" v-model="review.ratings" v-if="review.rubrics.criteria.length > 1" />
        <blockquote v-html="(display == 'given') ? review.revieweeUserAssignment.reviewQuestion.response : review.review"></blockquote>
        <p v-if="display == 'given'" v-html="review.review"></p>
      </div>
    </transition>
  </div>
</template>

<script>

  export default {
    name: 'PeerReview',
    props: {
      review: {
        type: Object,
        required: true
      },
      display: {
        type: String,
        default: "received"
      }
    },
    data () {
      return {
        displayName: (this.display == "given") ? this.review.reviewOf : this.review.reviewBy,
        showResponse: false
      }
    },
    methods: {
      toggleResponse () {
        this.showResponse = !this.showResponse
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  .upper {
    display:flex; align-items:center;
    button {
      @include transition();
      flex:2; text-align:left; font-size:inherit;
      &:hover, &:focus {
        color:$color-primary;
      }
      &:hover svg, &:focus svg {
        fill:$color-primary;
      }
    }
    .down-arrow {
      @include transition();
      @include size(1.5rem);
      transform:rotate(-90deg);
    }
    .active > & {
      .down-arrow {
        transform:rotate(0);
      }
    }
    .ratings {
      display:flex;
      svg {
        @include size(2rem);
      }
    }
  }

  blockquote {
    word-wrap:break-word;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/peer-reviews/peer-review.vue